export default __webpack_public_path__ + "static/media/img1.0832da06.png";